import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header/index.js";
import Body from "./components/Body/Body";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { CookieSetting } from "cookiesetting-component";


import february2024 from "./components/Body/february2024.json";

// Lazy-loaded components
const Footer = lazy(() => import("./components/FooterNew/index.js"));
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() => import("./components/Morganlogos/Morganlogos.js"));
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));
const EventComponent = lazy(() => import("./components/Event/Event.js"));
const Testimonial = lazy(() => import("./components/Testimonials/Testimonials.js"));

function App() {
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [EventsData, setEventsData] = useState();
  const [formData, setFormData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [links, setLinks] = useState(null);

  const appVersion = appversion.version;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_CDN_LINK + "mastermind/february2024/february2024.json");
        const webinarJsonData = response.data;
        setWebinarData(webinarJsonData);
        setBannerData(webinarJsonData.banner);
        setHighlightsData(webinarJsonData.highlights);
        setPropertyData(webinarJsonData.property);
        setEventsData(webinarJsonData.Events);
        setFormData(webinarJsonData.signupform);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error or set default data
      }
    };

    fetchData();

    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_CDN_LINK + "jsons/ai-branding.json");
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData);
      }
    };

    if (!links) {
      fetchLinks();
    }
  }, [links]);

  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={"."}
      >
        <>
          <Header fetchpriority="high" aiBrandingData={aiBrandingData} />
          {bannerData &&
            <Body bannerData={bannerData} formData={formData} links={links} fetchpriority="high" />
          }
          <Suspense fallback={<div />}>
            {highlightsData &&
              <Highlights highlightsData={highlightsData} links={links} />
            }
          </Suspense>
          <Suspense fallback={<div />}>
            {propertyData &&
              <Proprty propertyData={propertyData} links={links} />
            }
          </Suspense>
          <Suspense fallback={<div />}>
            {EventsData && links ? (
              <EventComponent EventsData={EventsData} links={links} fetchpriority="low" />
            ) : (
              <Spinner animation="border" role="status" />
            )}
          </Suspense>
          <Suspense fallback={<div />}>
            <Testimonial links={links} fetchpriority="low" />
          </Suspense>
          <Suspense fallback={<div />}>
            {links && (
              <Morganlogos links={links} fetchpriority="low" />
            )}
          </Suspense>
          <Suspense fallback={<div />}>
            {links && (
              <Whysunwest links={links} fetchpriority="low" />
            )}
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
        </>
        <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />

      </CacheBuster>
    </div>
  );
}

export default App;
